import router from '@/router'

const permissions = ['/dataV', '/educationalTraining', '/hiddenCheck', '/home', '/riskManagement', '/riskWork', '/setting', '/emergencyManagement']

function filterPermissionsRouters(routes, roles) {
  const res = []
  // routes.forEach((route) => {
  //   const children = [];
  //   route.children?.forEach((childRouter) => {
  //     const roleCode = childRouter.meta?.roleCode || childRouter.name;
  //     if (roles.indexOf(roleCode) !== -1) {
  //       children.push(childRouter);
  //     }
  //   });
  //   if (children.length > 0) {
  //     route.children = children;
  //     res.push(route);
  //   }
  // });
  return res
}

const state = {
  whiteListRouters: [ // 白名单
    '/login',
    '/info/hiddenList',
    '/info/unitMulti',
    '/info/hiddenPage',
    '/info/admin',
    '/info/riskCheck',
    '/info/riskList',
    '/info/base',
    '/info/hidden',
    '/info/risk',
    '/info/echart',
    '/info/unit',
    '/info/emergency',
    '/info/accident',
    '/info/hiddenInfo',
    '/info/education',
    '/info/5SManage',
    '/info/performanceManage',
    '/info/hidenCheck',
    '/info/majiorHidden',
    '/info/securityCheck',
    '/info/managementPage',
    '/info/riskInventory', // 风险管控-风险清单
    '/info/supervisionCheck', // 监督检查
    '/info/supervisionCheck/check_manage',
    '/info/supervisionCheck/check_object',
    '/info/supervisionCheck/check_quest',
    '/info/supervisionCheck/check_task',
    '/info/supervisionCheck/handover_tracking',
    '/info/supervisionCheck/trace_table',
    '/info/supervisionCheck/statistics',
    '/info/supervisionCheck/dynamic_manage',
    '/info/supervisionCheck/check_deployment',
    '/info/supervisionCheck/planned_deployment',
    '/info/supervisionCheck/expert_database',
    '/info/supervisionCheck/industry_field',
    '/info/supervisionCheck/grid_staff',
    '/info/supervisionCheck/special_project',
    '/info/supervisionCheck/hidden_danger',
    '/info/supervisionCheck/subject_responsibility',
    '/riskManagement/index',
    '/hiddenCheck/hidenList/hideenMaintain',
    '/info/announceAgency',
    '/info/announceService'
  ],
  routers: []
}

const mutations = {
  setRouters: (state, routers) => {
    state.routers = routers
  }
}

const getters = {
  routers: (state) => state.routers,
  whiteListRouters: (state) => state.whiteListRouters
}

const actions = {
  async initRoutes({ commit }, userInfo) {
    let newRouter = [...router.options.routes]
    let i = newRouter.length
    while (i--) {
      if (userInfo.auth_list && !userInfo.auth_list.includes(newRouter[i].path)) {
        newRouter.splice(i, 1)
      }
    }
    commit('setRouters', [...newRouter])
  },
  async restore({ commit }) {
    resetRouter()
    commit('setRouters', [])
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/permission.js